<h2 class="mb-5">{{'IDEALPROFILE.TITLE' |translate}}</h2>

<div class="card mb-4 border-0 shadow-sm">
  <div class="card-header bg-white pt-4 border-bottom-0">
    <h5>{{ 'CANDIDATES.SEARCHFILTERS' | translate }}</h5>
  </div>

  <div class="card-body">
    <form [formGroup]="profileSearchForm" (ngSubmit)="onSubmit()">
      <div class="form-row">

        <div class="form-group col-4">
          <label for="jobtype">{{'IDEALPROFILE.ASOCIATEDJOBTYPE' |translate}}</label>
          <select class="form-control" id="jobtype" formControlName="jobtype">
            <option [ngValue]="null" hidden>{{ 'INVITE.SELECTJOBTYPE' | translate }}</option>
            <option [ngValue]="null">{{'COMMON.ALL' |translate}}</option>
            <option *ngFor="let jobtype of jobtypes$ | async" [ngValue]="jobtype">{{ jobtype.name | titlecase }}</option>
          </select>
        </div>

        <div class="form-group col-3">
          <label>&nbsp;</label>
          <button type="submit" class="btn btn-primary form-control">
            <i class="fa fa-search"></i> {{ 'COMMON.SEARCH' | translate }}
          </button>
        </div>
      </div>
    </form>
  </div>
</div>

<ct-datatable class="datatable" [items$]="profiles$" (reload)="searchProfiles($event.page, profileSearchForm.get('jobtype').value)">

  <thead>
    <tr>
      <th colspan="1" id="results">{{ 'CANDIDATES.ALLRESULTS' | translate }} ({{ (profiles$ | async)?.total || 0 }})
      </th>
      <th colspan="2"></th>
      <th colspan="1" id="actions">
        <div ngbDropdown placement="bottom-right">
          <div ngbDropdownToggle> {{'CANDIDATES.ACTIONS' |translate}} </div>
          <div ngbDropdownMenu>
            <button ngbDropdownItem routerLink="/consultant/profiles/create">{{'IDEALPROFILE.ADD' |translate}}</button>
          </div>
        </div>
      </th>
    </tr>
  </thead>

  <thead>
    <tr>
      <th>{{'IDEALPROFILE.PROFILEID' |translate}}</th>
      <th>{{'IDEALPROFILE.CREATOR' |translate}}</th>
      <th>{{'IDEALPROFILE.NAME' |translate}}</th>
      <th>{{'CANDIDATES.ACTIONS' |translate}}</th>
    </tr>
  </thead>

  <tbody class="bg-white">
    <tr *ngFor="let profile of (profiles$ | async)?.data; index as i"  [ngClass]="{disabledRow: profile.isUb}">
      <ng-container *ngIf="profile.jobtype">
        <td>{{ profile.id }} </td>
        <!-- <td>{{ process.jobtypeId || '-' }}</td> -->
        <td><img *ngIf="profile.isUb" src="/assets/images/randstad-icon.png" alt="Randstad" class="randstad-icon"></td>
        <td class="profileName" [routerLink]="['/consultant/profiles/detail', profile.id]">{{ profile.name }}</td>
        <td>
          <i class="fa fa-edit" [routerLink]="profile.isUb? null : ['/consultant/profiles/edit', profile.id]" [ngbTooltip]="(profile.isUb? 'TOOLTIP.UNABLEEDIT' :'TOOLTIP.EDIT') | translate"></i>
          <i class="fa fa-trash" (click)="profile.isUb ? null : showModalDeleteProfile(profile)" [ngbTooltip]="(profile.isUb? 'TOOLTIP.UNABLEDELETE' :'TOOLTIP.DELETE') | translate"></i>
        </td>
      </ng-container>
    </tr>
    <tr *ngIf="!(profiles$ | async)?.data">
      <td colspan="8" class="text-center">{{ 'CANDIDATES.NORESULTS' | translate }}</td>
    </tr>
  </tbody>
</ct-datatable>


<ng-template #content let-modal>
  <div class="modal-header border-bottom-0">
    <h5 class="modal-title">{{ 'COMMON.DELETE' | translate }}</h5>
    <div id="closeModal">
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>&nbsp;
      </button>
    </div>
  </div>

  <div class="modal-body">
    <p>{{'IDEALPROFILE.DELETECONFIRM' |translate}}</p>
  </div>
  <div class="modal-footer justify-content-center">
    <button type="button" class="btn btn-secondary"
      (click)="modal.dismiss('cancel click')">{{ 'COMMON.CANCEL' | translate }}</button>
    <button type="button" class="btn btn-primary" (click)="deleteProfile()">OK</button>
  </div>
</ng-template>
